import React from 'react'
import Wave from 'react-wavify'
import vision from '../../Image/vision.svg'
import mision from '../../Image/mission.svg'
import value from '../../Image/value.svg'
import career from '../../Image/career.png'
import arrow from '../../Image/right_arrow.svg'
import { useNavigate } from 'react-router-dom'

const AboutSection4 = () => {

  const navigate = useNavigate()

  return (
   <>
    <div className='relative overflow-hidden sm:top-[-80px] top-[-80px] z-20  '>
        <Wave fill='white'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 30,
              speed: 0.3,
              points: 5
            }}
            className='relative min-w-[1920px] sm:h-[40px] h-[30px] '
           />
   </div>

        <div className=''>
           <div className='container'>
               <div className='border-[1px] border-[#8A49D6] rounded-[30px] shadow-[0_0_4px_0_#00000040] ' data-aos="zoom-in">
                  <div className='ds_rainbow' >
                      <div className='flex lg:flex-nowrap flex-wrap justify-center  pb-8'>
                         <div className="lg:w-1/3 md:w-1/2 w-full flex flex-col justify-center items-center relative ">
                            <div className='lg:absolute lg:top-[-55px] w-[100px] h-[100px] bg-[white] backdrop-blur-[8px] rounded-[50%] flex justify-center align-middle'>
                                   <img src={vision} alt="" className='w-[50px] ' />
                            </div>
                            <h4 className='text-txt_color sm:text-[24px] text-[18px] font-[700] text-center lg:mt-11 pt-5'>Our Vision​</h4>
                            <p className='sm:text-[16px] text-[14px] text-[#555555] text-center lg:px-10 sm:px-7 px-2 mt-2'>Our vision is to lead the way in revolutionizing technology for positive change and limitless possibilities.</p>
                         </div>
                         <div className="lg:w-1/3 md:w-1/2 w-full flex flex-col justify-center items-center relative md:mt-0 mt-5">
                            <div className='lg:absolute lg:top-[-55px] w-[100px] h-[100px] bg-[white] backdrop-blur-[8px] rounded-[50%] flex justify-center align-middle'>
                                   <img src={mision} alt="" className='w-[50px] ' />
                            </div>
                            <h4 className='text-txt_color sm:text-[24px] text-[18px] font-[700] text-center lg:mt-11 pt-5'>Our Mission​</h4>
                            <p className='sm:text-[16px] text-[14px] text-[#555555] text-center lg:px-10 sm:px-7 px-2 mt-2'>Our mission is to convert imagination into actuality by providing our team with a positive work area and latest technology.</p>
                         </div>
                         <div className="lg:w-1/3 md:w-1/2 w-full flex flex-col justify-center items-center relative lg:mt-0 md:mt-4 mt-5">
                            <div className='lg:absolute lg:top-[-55px] w-[100px] h-[100px] bg-white/30 backdrop-blur-md rounded-[50%] flex justify-center align-middle'>
                                   <img src={value} alt="" className='w-[50px] ' />
                            </div>
                            <h4 className='text-txt_color sm:text-[24px] text-[18px] font-[700] text-center lg:mt-11 pt-5'>Core Value​</h4>
                            <p className='sm:text-[16px] text-[14px] text-[#555555] text-center lg:px-10 sm:px-7 px-2 mt-2'>We hand over an effective results for our clients by learning from the past and collaborating on change for the future.</p>
                         </div>
                      </div>
                  </div>
               </div>

               <div className='mt-11 sm:pt-10 pt-5 mb-11 sm:pb-10'>
                   <div className='flex lg:flex-nowrap flex-wrap items-center'>
                      <div className='lg:w-1/2 w-full'>
                         <img src={career} alt="" className='lg:w-[680px] w-[550px]' data-aos="fade-right" />
                      </div>
                      <div className='2xl:w-2/5 lg:w-1/2 w-full lg:mt-0 mt-5'>
                          <div className='3xl:ps-0 lg:ps-11'>
                             <h2 className="md:text-[60px] sm:text-[40px] sx:text-[30px] text-[28px] font-[700] text-theme_dark ">Career</h2>
                             <div className='2xl:pe-10 3xl:me-10'>
                               <h4 className='text-txt_color sm:text-[24px] text-[18px] font-[700] '>Teamwork is the force behind every successful business.</h4>
                               <p className='sm:text-[16px] text-[14px] text-[#555555] mt-4 text-justify'>At KALATHIYA Infotech, we believe in empowering talent, fostering innovation, and creating technology that impacts millions. Whether you're a seasoned professional or a passionate fresher, you'll find a place to grow, learn, and make a real difference.</p>
                             </div>
                             <button onClick={()=> navigate("/contact")} className='ds_contact_btn flex items-center justify-around mt-5'><div className='ms-2'>Contact Us</div> <div className='ds_btn_round w-[34px] h-[34px] bg-white rounded-[50%] flex justify-center items-center'> <img src={arrow} alt="" className='ds_btn_svg' /> </div></button>
                          </div>
                      </div>
                   </div>
               </div>
           </div>
        </div>
    </>
  )
}

export default AboutSection4
